import { DialogModule, DialogRef } from '@angular/cdk/dialog';

import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Input, Renderer2, Signal, ViewChild } from '@angular/core';
import { LayoutService } from '@services/layout.service';
import anime from 'animejs';

@Component({
    selector: 'app-dialog-container',
    imports: [DialogModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dialog-container.component.html',
    styleUrl: './dialog-container.component.css'
})
export class DialogContainerComponent implements AfterViewInit {
  private readonly dialogRef = inject(DialogRef);
  private readonly elementRef: ElementRef = inject(ElementRef);
  private readonly renderer: Renderer2 = inject(Renderer2);
  public  readonly isMobile: Signal<boolean> = inject(LayoutService).isMobile;
  
  @Input() showCloseButton:  boolean = true;
  @Input() noContentPadding: boolean = false;

  @ViewChild('dialog') public dialog!: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    this.setCloseListener();
    this.animate();
  }

  private setCloseListener(): void {
    const closeElements = this.elementRef.nativeElement.querySelectorAll('[data-dialog-close]');
    closeElements.forEach((el: HTMLElement) => {
      this.renderer.listen(el, 'click', () => this.close());
    });
  }

  private animate(): void {
    anime({
      targets: this.dialog.nativeElement,
      opacity: [0, 1],
      duration: 200,
      easing: 'easeInQuad'
    });
  }

  public close(): void {
    this.dialogRef.close();
  }
}
